import { z } from "zod";
import { ModelDefinition } from "../base-components/hooks/useModel";
import { getPropertyKey, savePropertyKey, createPropertyKeyAndGetId } from "../api/property-key-controller";
import { RoutePath } from "@/generic/config";

export const PropertyTypeEnum = z.enum(['STRING', 'BOOLEAN']);
export type PropertyType = z.infer<typeof PropertyTypeEnum>;

export const PropertyKeySchema = z.object({
    id: z.number(),
    objectType: z.string(),
    propertyType: PropertyTypeEnum,
    key: z.string(),
});
export type PropertyKey = z.infer<typeof PropertyKeySchema>;

export const PropertyValueSchema = z.object({
    id: z.number(),
    objectType: z.string(),
    objectId: z.number(),
    propertyKey: PropertyKeySchema,
    value: z.string(),
});
export type PropertyValue = z.infer<typeof PropertyValueSchema>;

export const emptyPropertyKeyObject: PropertyKey = {
    id: 0,
    objectType: "worksite",
    propertyType: "STRING",
    key: "",
};

export const PropertyKeyModel: ModelDefinition<PropertyKey> = {
    getById: getPropertyKey,
    saveFromModel: savePropertyKey,
    createFromModel: createPropertyKeyAndGetId,
    validationMessages: () => [],
    routePath: RoutePath.Properties,
    typeProviderObject: PropertyKeySchema.parse(emptyPropertyKeyObject),
};
